import React from 'react'

type Props = {
  css: string | undefined | null
}

export const RenderInlineStyle = ({ css }: Props) => {
  return css ? <style dangerouslySetInnerHTML={{ __html: css }}></style> : null
}
